import { render, staticRenderFns } from "./customer_level.vue?vue&type=template&id=2d598be0&"
import script from "./customer_level.vue?vue&type=script&lang=js&"
export * from "./customer_level.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports